import React, { createContext, useState } from 'react';

interface ChatContextProps {
  isChatOpen: boolean;
  setIsChatOpen: (chatOpen: boolean) => void;
  toggleChatBox: () => void;
}

export const ChatContext = createContext<ChatContextProps>({
  isChatOpen: false,
  setIsChatOpen: () => {},
  toggleChatBox: () => {},
});

interface ChatProviderProps {
  children: React.ReactNode;
}

export const ChatProvider: React.FC<ChatProviderProps> = ({ children }) => {
  const [isChatOpen, setIsChatOpen] = useState<boolean>(false);

  const toggleChatBox = () => setIsChatOpen(!isChatOpen);

  return (
    <ChatContext.Provider value={{ isChatOpen, setIsChatOpen, toggleChatBox }}>
      {children}
    </ChatContext.Provider>
  );
};
